import requester from 'utils/requester';
import api from 'config/api';
import urlHelper from 'helpers/urlhelper';
import { getIsLoggedInSelector } from 'reducers/profile/selectors';
import * as types from './types';

export const fetchMenu = () => async (dispatch, getState, history) => {
  const isLoggedIn = getIsLoggedInSelector(getState());
  const endpoint = urlHelper.getAuthorizedEndpointUrl(api.endpoints.menu, isLoggedIn);

  try {
    dispatch({ type: types.FETCH });

    const data = await requester({
      method: 'get',
      url: `${api.host}${endpoint}`,
      params: { subDashboards: true },
    });
    dispatch(onFetchSuccess(data));
  } catch (error) {
    dispatch(onFetchError(error));
    history.push('technical-stub');
  }
};

const onFetchSuccess = (payload) => ({ type: types.FETCH_SUCCESS, payload });

const onFetchError = (payload) => ({ type: types.FETCH_ERROR, payload });

export const setMenuIdle = (payload) => ({ type: types.SET_IDLE, payload });

export const setIsMenuVisible = (payload) => ({ type: types.SET_IS_VISIBLE, payload });
